
const DEPLOYMENTS_RECEIVED = "EVT_DEPLOYMENTS_RECEIVED";
const DEPLOYMENTS_REQUESTED = "EVT_DEPLOYMENTS_REQUESTED";
const DEPLOYMENTS_RETRIEVAL_FAILED = "EVT_DEPLOYMENTS_RETRIEVAL_FAILED";

const createDeploymentsReceived = deployments => ({type: DEPLOYMENTS_RECEIVED, data: deployments});
const createDeploymentsRequested = () => ({type: DEPLOYMENTS_REQUESTED});
const createDeploymentsRetrievalFailed = () => ({type: DEPLOYMENTS_RETRIEVAL_FAILED})
const deployments = model => (model || {}).dEpl0_deployments || [];
const requested = model => (model || {}).dEpl0_requested || false;

const update = (model, event) => {

    model = model || {};

    if (event) {
        switch (event.type) {
            case DEPLOYMENTS_RECEIVED:
                return {...model, dEpl0_requested: false, dEpl0_deployments: event.data};
            case DEPLOYMENTS_REQUESTED:
                return {...model, dEpl0_requested: true};
            case DEPLOYMENTS_RETRIEVAL_FAILED:
                return {...model, dEpl0_requested: false};
            default: break;
        }
    }

    return model;
};

const eventTypes = {
    DEPLOYMENTS_RECEIVED,
    DEPLOYMENTS_REQUESTED,
    DEPLOYMENTS_RETRIEVAL_FAILED
};

export {
    update,
    createDeploymentsReceived,
    createDeploymentsRequested,
    createDeploymentsRetrievalFailed,
    deployments,
    requested,
    eventTypes
}



// WEBPACK FOOTER //
// ./src/deployments/model.js